import { useEffect, useState } from "react";
import { useUser } from "./UserContext";
import {
    Modal,
    ModalDialog,
    Typography,
    Input,
    Button,
} from "@mui/joy";
import * as React from "react";
import Box from "@mui/joy/Box";
import ApiService from "../../axios/Axios";

function PhoneNumberChecker() {
    const { user, isLoading } = useUser();
    const [validPhone, setValidPhone] = useState<boolean>(true);
    const [showError, setShowError] = useState<boolean>(false);
    const [phoneInput, setPhoneInput] = useState<string>("");

    useEffect(() => {
        if (!isLoading && user) {
            if (!user.phone) {
                setValidPhone(false);
            }
        }
    }, [user, isLoading]);

    const handleSubmit = async () => {
        if(!phoneInput.startsWith('+44') || phoneInput.length != 13){
            setShowError(true)
            return
        }
        setShowError(false)

        try {
            const res = await ApiService.updatePhoneNumber(phoneInput)

            if (res.status == 200) {
                setValidPhone(true);
                // Optionally trigger a refresh of user context here
            } else {
                console.error("Failed to update phone number");
            }
        } catch (err) {
            console.error("Error updating phone number", err);
        }
    };

    return (
        <>
            <Modal
                open={!validPhone}
                disableEscapeKeyDown
                slotProps={{
                    backdrop: {
                        sx: {
                            pointerEvents: "none", // disables backdrop close
                        },
                    },
                }}
            >
                <ModalDialog
                    aria-labelledby="phone-modal-title"
                    sx={{
                        zIndex: 99999, // keep it on top of everything
                    }}
                >
                    <Box>
                        <Typography id="phone-modal-title" level="title-lg" sx={{mb: 0}}>
                            Enter a valid phone number
                        </Typography>
                        <Typography color={"neutral"} level="body-sm" sx={{mt: 0}}>
                            Please enter a valid UK phone number formatted like this: <Typography sx={{fontWeight: 500}}>+441234567891</Typography>
                        </Typography>
                    </Box>
                    <Input
                        placeholder="Enter your phone number"
                        value={phoneInput}
                        onChange={(e) => setPhoneInput(e.target.value)}
                    />
                    {showError && (
                        <Typography color={"danger"} level="body-sm" sx={{mt: 0}}>
                           Incorrect format, please format like this: <Typography sx={{fontWeight: 500}}>+441234567891</Typography>
                        </Typography>
                    )}
                    <Button onClick={handleSubmit} fullWidth>
                        Save
                    </Button>
                </ModalDialog>
            </Modal>
        </>
    );
}

export default PhoneNumberChecker;
